import Cookies from 'js-cookie'

export const formatCurrency = (amount) => {
  const currencyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD', // doesn't really matter if USD or CAD, they're visually the same.
  })

  return currencyFormatter.format(amount / 100)
}

export const getTotalPrice = (stripePlan) => {
  const { stripeCoupon = {}, price, taxes = [], fee = 0 } = stripePlan
  const hasCoupon = stripeCoupon && Object.keys(stripeCoupon).length > 0

  const basePrice = hasCoupon ? stripeCoupon.couponedPrice : price
  return basePrice + fee + taxes.reduce((prev, cur) => prev + cur.amount, 0)
}

export const getConversionType = () => {
  return Cookies.get('conversion_type') || ''
}

export const setOrUnsetCookie = (name, value, expiry) => {
  if (value) {
    Cookies.set(name, value, { expires: expiry })
  } else {
    Cookies.remove(name)
  }
}
